import { registerQuery } from 'data-fetching-client';

/* @ts-expect-error module is untyped */
import * as ecosystemClient from '../clients/ecosystemClient';
export const GET_REVIEWS = registerQuery({
  fieldName: 'reviewsResponse',
  args: ['queries'],
  fetcher({
    queries
  }) {
    return ecosystemClient.fetchReviews(queries);
  }
});
export const GET_REVIEW_STATS = registerQuery({
  fieldName: 'reviewStatsResponse',
  args: ['offeringId'],
  fetcher({
    offeringId
  }) {
    return ecosystemClient.fetchReviewsStats(offeringId);
  }
});